export const DEFAULT_OPTIONS = {
  history: false,
  focus: true,
  showAnimationDuration: 0,
  hideAnimationDuration: 0,
  clickToCloseNonZoomable: false,
  closeOnScroll: false,
  barsSize: {
    top: 90,
    bottom: 'auto',
  },
  spacing: 0.6,
  fullscreenEl: false,
  tapToToggleControls: false,
  shareButtons: [{
      id: 'facebook',
      label: __('Facebook'),
      url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}',
    },
    {
      id: 'twitter',
      label: __('Twitter'),
      url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}',
    },
    {
      id: 'pinterest',
      label: __('Pinterest'),
      url: 'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}',
    },
    {
      id: 'download',
      label: __('Descargar imagen'),
      url: '{{raw_image_url}}',
      download: true,
    },
  ],
  share: true,
  zoom: true,
  topBar: {
    defaultActions: [{
        label: __('Cerrar'),
        className: 'pswp__button--close icon icon-close-o',
      },
      {
        label: __('Compartir'),
        className: 'pswp__button--share icon icon-share-o',
      },
      {
        label: __('Zoom in/out'),
        className: 'pswp__button--zoom icon icon-plus-circle-o',
      },
    ],
    actions: [],
  },
};
